import { gql } from "apollo-boost";

const ADD_LAKE_VARIANT = gql`
  mutation addLakeVariant($input: AddLakeVariant) {
    addLakeVariant(input: $input) {
      data
      status
      error
    }
  }
`;
export default ADD_LAKE_VARIANT;
